import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const AutomobileEmailThread = Loadable(
  lazy(() =>
    import("./AutomobileEmailThread").then(({ AutomobileEmailThread }) => ({
      default: AutomobileEmailThread,
    }))
  )
);

export const AutomobileEmailThreadRoutes = [
  {
    path: "/automobile-policy/:customerId/email-thread/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <AutomobileEmailThread />
      </AuthorizedRoute>
    ),
  },
];
